export default __webpack_public_path__ + "static/media/b8.f82c84ee.jpg";